import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Add a script to handle image placeholders and other shared interactive elements
const enhanceUI = () => {
  // Enhanced image placeholders with hover effects
  setTimeout(() => {
    const placeholders = document.querySelectorAll('.bg-gray-200');
    placeholders.forEach((placeholder, index) => {
      // Add staggered animation delay for elements
      placeholder.style.animationDelay = `${index * 0.2}s`;
      
      placeholder.addEventListener('click', function() {
        // In a real application, this could trigger a modal or image selection
        console.log('Image placeholder clicked');
        this.classList.add('animate-pulse');
        
        // Remove the animation class after it completes
        setTimeout(() => {
          this.classList.remove('animate-pulse');
        }, 2000);
      });
      
      // Random subtle movement on mouseover
      placeholder.addEventListener('mouseover', function() {
        const randomTransform = Math.random() > 0.5 ? 'scale(1.02)' : 'scale(1.02) rotate(1deg)';
        this.style.transform = randomTransform;
      });
      
      placeholder.addEventListener('mouseout', function() {
        this.style.transform = '';
      });
    });

    // Enhance the header title with subtle animation
    const headerTitle = document.querySelector('.header-title');
    if (headerTitle) {
      headerTitle.addEventListener('mouseover', function() {
        this.style.textShadow = '2px 2px 4px rgba(0, 0, 0, 0.2)';
        this.style.letterSpacing = '1px';
        this.style.transition = 'all 0.3s ease';
      });
      
      headerTitle.addEventListener('mouseout', function() {
        this.style.textShadow = '1px 1px 2px rgba(0, 0, 0, 0.1)';
        this.style.letterSpacing = '0.5px';
      });
    }
  }, 500); // Give the React components time to mount
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// After the React app mounts, enhance the UI with similar behaviors to the original site
enhanceUI();
